var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6168 24 24 18.6168 24 12C24 5.38318 18.6168 0 12 0C5.38318 0 0 5.38318 0 12C0 18.6168 5.38318 24 12 24ZM12 1.55393C17.76 1.55393 22.446 6.24022 22.446 12C22.446 17.7598 17.76 22.446 12 22.446C6.23996 22.446 1.55393 17.7598 1.55393 12C1.55393 6.24022 6.23996 1.55393 12 1.55393ZM6.17272 13.4908H14.0586C14.0586 13.4908 12.147 15.4026 10.9628 16.5863C10.4573 17.0921 10.4573 17.9121 10.9628 18.4178C11.0462 18.5012 11.1307 18.5854 11.2141 18.6688C11.7196 19.1747 12.5396 19.1747 13.0454 18.6688C14.5953 17.1193 17.6708 14.0434 18.7431 12.9709C18.986 12.7283 19.1225 12.3988 19.1225 12.0554V11.9446C19.1225 11.6014 18.986 11.272 18.7431 11.029C17.6708 9.95674 14.5953 6.88095 13.0454 5.33134C12.5396 4.82554 11.7196 4.82554 11.2141 5.33134C11.1307 5.41449 11.0462 5.49921 10.9628 5.58231C10.4573 6.08815 10.4573 6.90789 10.9628 7.41368C12.147 8.59757 14.0586 10.5094 14.0586 10.5094H6.17272C5.45738 10.5094 4.87774 11.0893 4.87774 11.8044V12.1958C4.87774 12.9111 5.45738 13.4908 6.17272 13.4908Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkBtn);
export default __webpack_public_path__ + "static/media/link_btn.356f2e89d2ee8fb0031ca150de815835.svg";
export { ForwardRef as ReactComponent };